import React, {useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {Button, Spinner, Modal} from 'player-components';

import { selectClientConfig, setUserInputtingText } from '../../features/ui/uiSlice';


import NewSetlistModal from '../NewSetlistModal';

const AddToNewSetlistModal = ({song, firstSetlist, isOpen, onClose, onConfirm}) => {
    
    const clientConfiguration = useSelector(selectClientConfig);
    const [title, setTitle] = useState(null);
    const dispatch = useDispatch();
    const [subtitle, setSubtitle] = useState(null);
    const [imageUrl, setImageUrl] = useState(clientConfiguration.features.setlist.defaultSetlistImageUrl);
    
    const handleUserInputingText = (bool) => {
        dispatch(setUserInputtingText(bool));
      }

    return <Modal 
        title="Add song to new setlist"
        isOpen={isOpen}
        content={<div style={{minHeight: 300}}>
        <NewSetlistModal 
        isOpen={isOpen} 
        clientConfiguration={clientConfiguration} 
        firstSetlist={firstSetlist} 
        title={title} 
        setTitle={setTitle} 
        subtitle={subtitle} 
        setSubtitle={setSubtitle} 
        imageUrl={imageUrl} 
        setImageUrl={setImageUrl} 
        setUserInputtingText={handleUserInputingText}
        />
        </div>}
        closeLabel={'Close'}
        onClose={onClose}
        onConfirm={()=>onConfirm({title, subtitle, imageUrl})}
        confirmLabel={"Add song to new setlist"}
        confirmable={title && subtitle}
    />
}

export default AddToNewSetlistModal;